import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCaretRight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCaretRight extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '08dbb5ccebf6d40c76bcc0a52efbdd5eed17d537', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '93668a2c301825a2389c75d30812e67d2ef9e9ca', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '66e97465a28a4a61186b4796745af9e672447ca9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.79 10.79 8.51 5.51a.3.3 0 0 0-.51.21v10.56a.3.3 0 0 0 .51.21l5.28-5.28a.29.29 0 0 0 0-.42", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-caret-right", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-caret-right"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-caret-right":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCaretRight$1);
            }
            break;
    } });
}

const CosmosIconCaretRight = CosmosIconCaretRight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCaretRight, defineCustomElement };
